import type { QueryAttribute } from '@lib/types/query-builder.types'

export function getQueryBuilderFilterIteratee(filters: QueryAttribute[]) {
  return (item: any) =>
    filters.every((filter) => {
      const value = item[filter.property]

      switch (filter.operator) {
        case 'contains':
          return String(value).includes(filter.value as string)
        case 'not_contains':
          return !String(value).includes(filter.value as string)
        case 'true':
          return Boolean(value)
        case 'false':
          return !value
        case 'eq':
          // intentional use of == to compare values
          return value == filter.value
        case 'neq':
          // intentional use of != to compare values
          return value != filter.value
        case 'gt':
          return Number(value) > Number(filter.value)
        case 'gte':
          return Number(value) >= Number(filter.value)
        case 'lt':
          return Number(value) < Number(filter.value)
        case 'lte':
          return Number(value) <= Number(filter.value)
        default:
          return true
      }
    })
}
